(function () {
  'use strict';

  var gallerySelector = '[data-arb-gallery]';

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function largestImageSrc(image) {
    if (!(image instanceof HTMLImageElement)) return '';

    var srcset = image.getAttribute('srcset');
    if (!srcset) return image.currentSrc || image.src || '';

    var bestWidth = 0;
    var bestUrl = image.currentSrc || image.src || '';

    srcset.split(',').forEach(function (entry) {
      var parts = entry.trim().split(/\s+/);
      if (!parts.length) return;

      var url = parts[0];
      var width = parseInt(parts[1], 10) || 0;
      if (width >= bestWidth) {
        bestWidth = width;
        bestUrl = url;
      }
    });

    return bestUrl;
  }

  function getCarouselIndex(carousel, slideCount) {
    return clamp(Math.round(carousel.scrollLeft / Math.max(carousel.clientWidth, 1)), 0, Math.max(slideCount - 1, 0));
  }

  function syncGalleryDots(gallery, index) {
    var dots = gallery.querySelectorAll('[data-blossom-dot]');
    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    syncRovingTabindex(gallery, index);
  }

  function syncGalleryCarousel(gallery, index) {
    var carousel = gallery.querySelector('blossom-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-blossom-slide]');
    var slide = slides[index];
    if (!slide) return;

    carousel.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    syncGalleryDots(gallery, index);
  }

  function buildLightbox(gallery) {
    var closeLabel = gallery.getAttribute('data-arb-lightbox-close') || 'Close';
    var prevLabel = gallery.getAttribute('data-arb-lightbox-prev') || 'Previous';
    var nextLabel = gallery.getAttribute('data-arb-lightbox-next') || 'Next';
    /* a11y: the dialog's own name. This used to be closeLabel, so the lightbox
       announced itself as "Close, dialog" — the close button's name standing in for
       the dialog's. */
    var dialogLabel = gallery.getAttribute('data-arb-lightbox-label') || 'Product image gallery';

    var lightbox = document.createElement('div');
    lightbox.className = 'arb-gallery-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', dialogLabel);
    lightbox.innerHTML =
      '<div class="arb-gallery-lightbox__backdrop" data-arb-lightbox-close tabindex="-1"></div>' +
      '<button type="button" class="arb-gallery-lightbox__close" data-arb-lightbox-close aria-label="' +
      closeLabel.replace(/"/g, '&quot;') +
      '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '</svg></button>' +
      '<div class="arb-gallery-lightbox__toolbar">' +
      '<button type="button" class="arb-gallery-lightbox__nav" data-arb-lightbox-prev aria-label="' +
      prevLabel.replace(/"/g, '&quot;') +
      '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>' +
      '</button>' +
      '<p class="arb-gallery-lightbox__counter" aria-live="polite">' +
      '<span data-arb-lightbox-current>1</span> / <span data-arb-lightbox-total>1</span>' +
      '</p>' +
      '<button type="button" class="arb-gallery-lightbox__nav" data-arb-lightbox-next aria-label="' +
      nextLabel.replace(/"/g, '&quot;') +
      '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="arb-gallery-lightbox__track" tabindex="-1"></div>';

    document.body.appendChild(lightbox);

    return {
      root: lightbox,
      track: lightbox.querySelector('.arb-gallery-lightbox__track'),
      currentEl: lightbox.querySelector('[data-arb-lightbox-current]'),
      totalEl: lightbox.querySelector('[data-arb-lightbox-total]'),
      prevButton: lightbox.querySelector('[data-arb-lightbox-prev]'),
      nextButton: lightbox.querySelector('[data-arb-lightbox-next]'),
      closeButtons: lightbox.querySelectorAll('[data-arb-lightbox-close]')
    };
  }

  function collectSlides(gallery) {
    var carousel = gallery.querySelector('blossom-carousel');
    if (!carousel) return [];

    return Array.prototype.slice.call(carousel.querySelectorAll('[data-blossom-slide]')).filter(function (slide) {
      return !slide.hidden;
    }).map(function (slide) {
      var image = slide.querySelector('img.arb-product-gallery__image') || slide.querySelector('img');
      return {
        slide: slide,
        image: image,
        src: largestImageSrc(image),
        alt: image && image.alt ? image.alt : ''
      };
    }).filter(function (item) {
      return item.src;
    });
  }

  function renderLightboxSlides(ui, items) {
    ui.track.innerHTML = '';

    items.forEach(function (item, index) {
      var panel = document.createElement('div');
      panel.className = 'arb-gallery-lightbox__slide';
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-roledescription', 'slide');
      panel.setAttribute('aria-label', String(index + 1));

      var img = document.createElement('img');
      img.className = 'arb-gallery-lightbox__image';
      img.src = item.src;
      img.alt = item.alt;
      img.decoding = 'async';
      img.loading = index === 0 ? 'eager' : 'lazy';

      panel.appendChild(img);
      ui.track.appendChild(panel);
    });

    ui.totalEl.textContent = String(items.length);
  }

  function updateLightboxCounter(ui, index, total) {
    ui.currentEl.textContent = String(index + 1);
    ui.totalEl.textContent = String(total);
    ui.prevButton.disabled = index <= 0;
    ui.nextButton.disabled = index >= total - 1;
  }

  function scrollLightboxToIndex(ui, index, behavior) {
    var slides = ui.track.querySelectorAll('.arb-gallery-lightbox__slide');
    var slide = slides[index];
    if (!slide) return;

    ui.track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'auto' });
    updateLightboxCounter(ui, index, slides.length);
  }

  function bindLightboxTrack(ui, onIndexChange) {
    var scrollTimer;

    ui.track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var slides = ui.track.querySelectorAll('.arb-gallery-lightbox__slide');
          if (!slides.length) return;

          var index = clamp(Math.round(ui.track.scrollLeft / Math.max(ui.track.clientWidth, 1)), 0, slides.length - 1);
          updateLightboxCounter(ui, index, slides.length);
          if (typeof onIndexChange === 'function') onIndexChange(index);
        }, 80);
      },
      { passive: true }
    );
  }

  /* a11y (ARB-322/323): the lightbox activators. One button per slide, wrapping the
     image itself, so the stop focus lands on is the stop that opens the lightbox —
     replacing the old pairing of a focusable-but-inert carousel and a separate zoom
     button.

     ⚠️ blossom-carousel CLONES the first and last slides for its loop, and the clones
     are what makes a naive `querySelectorAll('[data-arb-gallery-open]')` wrong. On
     contour-sander that query returns ELEVEN activators for nine images: a leading clone
     of image 9 and a trailing clone of image 1, neither carrying an id and — the useful
     part — neither carrying `data-blossom-slide`. The first version of this code counted
     them, so `tabindex="0"` went to the LEADING CLONE, which sits at `offsetLeft: 0`
     while the carousel is scrolled to 636, and every one of the nine real activators was
     left at -1. Tab focused a correctly-ringed button that was off-screen, and all nine
     real images were unreachable.

     Caught by looking at the screenshot and finding no ring on the image — the probe
     scored it PASS, because exactly one activator WAS in the tab order and it did open
     the lightbox. So: real slides only, discriminated by `data-blossom-slide`. */
  function realSlideActivators(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-blossom-slide] [data-arb-gallery-open]'));
  }

  function activators(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-arb-gallery-open]'));
  }

  /* Roving tabindex, applied to the slide activators AND the thumbnails from the one
     place, because they track the same index and drifting apart is how a gallery ends
     up with two stops on one slide and none on another. */
  function syncRovingTabindex(gallery, index) {
    /* Clone activators are decorative duplicates of a real slide. They are pinned out of
       the tab order unconditionally, before anything else, so no arithmetic below can
       hand one a stop. */
    activators(gallery).forEach(function (el) {
      if (!el.closest('[data-blossom-slide]')) el.tabIndex = -1;
    });

    [realSlideActivators(gallery), Array.prototype.slice.call(gallery.querySelectorAll('[data-blossom-dot]'))].forEach(function (group) {
      var visible = group.filter(function (el) {
        var slide = el.closest('[data-blossom-slide]');
        return !el.hidden && !(slide && slide.hidden);
      });
      if (!visible.length) return;
      var target = clamp(index, 0, visible.length - 1);
      visible.forEach(function (el, i) {
        el.tabIndex = i === target ? 0 : -1;
      });
    });
  }

  /* WCAG 2.4.3 / 2.1.2 for role="dialog" aria-modal="true": Tab and Shift+Tab must
     cycle INSIDE the dialog. Without this the lightbox was aria-modal in name only —
     one Tab off the close button landed on the page behind it, which is still
     scrolled and still visible through nothing. */
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapTab(root, event) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !root.contains(active)) {
        event.preventDefault();
        last.focus();
      }
      return;
    }

    if (active === last || !root.contains(active)) {
      event.preventDefault();
      first.focus();
    }
  }

  function initGallery(gallery) {
    var carousel = gallery.querySelector('blossom-carousel');
    if (!carousel) return;

    var openButtons = activators(gallery);
    if (!openButtons.length) return;

    /* ARB-334 — NO LIGHTBOX ON A TOUCH POINTER. Client review on iOS: "Can we
       remove the overlay it opens when you click on the product, it's really
       confusing." On a phone the stage is already a swipeable carousel, so the
       fullscreen overlay is a SECOND gesture surface over the same photos, opened
       by the same tap that a shopper uses to swipe. On a fine pointer,
       click-to-zoom is the PDP convention and nobody reported it, so it stays —
       the split is the pointer, not the viewport width.

       The activator is DOWNGRADED, not left inert: a <button> that announces
       "open image 1 of 8 in lightbox" and then does nothing is worse than no
       control at all. Swapping it for a plain <div> that keeps the same class
       costs no layout (the class carries all the positioning) and drops the
       element out of the tab order and the accessibility tree in one move. The
       `data-arb-gallery-open` hook goes with it, so realSlideActivators() stops
       finding it and syncRovingTabindex() manages only the dots — each of its two
       groups already returns early when empty. The stage zoom control is removed
       because it names an affordance that is no longer there (CSS also hides it
       at `(pointer: coarse)` so it never paints for a frame).

       Not re-evaluated on resize: `pointer` does not change with rotation, and a
       device that gains a mouse mid-session reloads long before it matters. */
    if (window.matchMedia('(pointer: coarse)').matches) {
      openButtons.forEach(function (button) {
        var plain = document.createElement('div');
        plain.className = button.className;

        while (button.firstChild) {
          plain.appendChild(button.firstChild);
        }

        button.parentNode.replaceChild(plain, button);
      });
      var zoom = gallery.querySelector('[data-arb-gallery-zoom]');
      if (zoom) zoom.remove();
      return;
    }

    var ui = buildLightbox(gallery);
    var items = collectSlides(gallery);
    if (!items.length) {
      ui.root.remove();
      var unusedZoom = gallery.querySelector('[data-arb-gallery-zoom]');
      if (unusedZoom) unusedZoom.remove();
      return;
    }

    var activeIndex = 0;
    var lastFocus = null;

    function openLightbox(startIndex) {
      items = collectSlides(gallery);
      if (!items.length) return;

      activeIndex = clamp(startIndex, 0, items.length - 1);
      lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      /* The stage zoom control is mouse-only (`tabindex="-1"`). Returning
         focus there would leave Tab sitting past the image activator. Hand
         it back to the slide that opened, which is the real keyboard stop. */
      if (lastFocus && lastFocus.hasAttribute('data-arb-gallery-zoom')) {
        var returnTo = realSlideActivators(gallery).filter(function (el) {
          var slide = el.closest('[data-blossom-slide]');
          return !(slide && slide.hidden);
        })[activeIndex];
        if (returnTo) lastFocus = returnTo;
      }

      renderLightboxSlides(ui, items);
      ui.root.hidden = false;
      document.body.classList.add('arb-gallery-lightbox-open');

      requestAnimationFrame(function () {
        scrollLightboxToIndex(ui, activeIndex, 'auto');
        ui.root.classList.add('is-open');
        ui.track.focus({ preventScroll: true });
      });
    }

    function closeLightbox() {
      if (ui.root.hidden) return;

      ui.root.classList.remove('is-open');
      ui.root.hidden = true;
      document.body.classList.remove('arb-gallery-lightbox-open');
      syncGalleryCarousel(gallery, activeIndex);

      /* Focus returns to the activator that opened it — which, now that the image is
         the activator, is the image the shopper was looking at. */
      if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') {
        if (lastFocus.hasAttribute && lastFocus.hasAttribute('data-arb-gallery-open')) lastFocus.tabIndex = 0;
        lastFocus.focus({ preventScroll: true });
      }
    }

    bindLightboxTrack(ui, function (index) {
      activeIndex = index;
    });

    function navigateLightbox(delta) {
      var slides = ui.track.querySelectorAll('.arb-gallery-lightbox__slide');
      if (!slides.length) return;

      var nextIndex = clamp(activeIndex + delta, 0, slides.length - 1);
      activeIndex = nextIndex;
      scrollLightboxToIndex(ui, nextIndex, 'smooth');
    }

    /* Enter and Space come free with <button type="button">, so there is no keydown
       handler here and none should be added. */
    function currentActivatorIndex(preferred) {
      /* Indexed against REAL slides, for the same clone reason as the roving
         tabindex: a clone is not in this list, so it falls through to the carousel's
         own active index rather than resolving to the wrong photo. Clones stay
         clickable — one is on screen mid-loop — they just are not tab stops. */
      var visible = realSlideActivators(gallery).filter(function (el) {
        var slide = el.closest('[data-blossom-slide]');
        return !(slide && slide.hidden);
      });
      var index = preferred ? visible.indexOf(preferred) : -1;
      if (index < 0) {
        index = parseInt(carousel.getAttribute('data-active-index'), 10);
        if (!(index >= 0)) {
          var slides = carousel.querySelectorAll('[data-blossom-slide]:not([hidden])');
          index = getCarouselIndex(carousel, slides.length);
        }
      }
      return index;
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openLightbox(currentActivatorIndex(button));
      });
    });

    /* Stage-level zoom control: same job as clicking the current image, but
       sitting outside the carousel so a click cannot be eaten as a swipe.
       tabindex="-1" — not a keyboard stop; the image activator is. */
    var zoomButton = gallery.querySelector('[data-arb-gallery-zoom]');
    if (zoomButton) {
      zoomButton.addEventListener('click', function () {
        openLightbox(currentActivatorIndex(null));
      });
    }

    ui.prevButton.addEventListener('click', function () {
      navigateLightbox(-1);
    });

    ui.nextButton.addEventListener('click', function () {
      navigateLightbox(1);
    });

    ui.closeButtons.forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    /* DOCUMENT-level, not root-level, and that is the whole point of the listener.
       A handler bound to ui.root only fires while focus is already inside ui.root —
       so the moment anything put focus on <body> (clicking the backdrop, the browser
       resetting focus after the open animation, a third-party banner grabbing it) the
       trap went dead and Tab walked away into the page behind the modal. Guarded on
       `!ui.root.hidden` so it costs nothing while the lightbox is closed. */
    document.addEventListener('keydown', function (event) {
      if (ui.root.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }

      if (event.key === 'Tab') {
        trapTab(ui.root, event);
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        ui.prevButton.click();
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        ui.nextButton.click();
      }
    });
  }

  /* Both buy-box shapes resolve to a variant id: the option picker's hidden
     input[name="id"], or the MG1000 configurator's Setup radio. Shared by
     initVariantMedia and initPromoOverlays. */
  function variantIdFrom(target) {
    if (!target || !target.getAttribute) return '';
    var setupId = target.getAttribute('data-arb-setup-variant-id');
    if (setupId) return target.checked ? setupId : '';
    if (target.name === 'id') return target.value || '';
    return '';
  }

  /* arbt (ARB-346/347): variant-driven hero. A variant's photo is native
     Shopify data — variant.featured_media, set with the admin's variant image
     picker — and arb-product-gallery.liquid already opens the carousel on it.
     This is the client-side half: when the shopper switches variant without a
     reload, move the carousel to that variant's media.

     Both buy-box shapes resolve to a variant id and land here — the standard
     option picker writes the resolved variant to the form's hidden
     input[name="id"] and fires change on it, and the MG1000 family
     configurator carries it on the Setup radio itself.

     This replaced arbortech.setup_media_map: a script-written JSON metafield
     with no metafield definition (so unreachable in the admin), holding raw
     media GIDs keyed on the exact option value string. It died silently on an
     option rename — allsaw-200x still held a map keyed "Corded" for a product
     whose only option is Voltage — and it HID the other setups' media, which
     nobody asked for. Jumping is the whole requirement. */
  function initVariantMedia(gallery) {
    var carousel = gallery.querySelector('blossom-carousel');
    if (!carousel || typeof carousel.goToIndex !== 'function') return;

    var dataEl = document.querySelector('[data-arb-variant-data]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (error) { return; }
    if (!variants) return;

    /* goToIndex counts real slides in DOM order — loop clones drop
       data-blossom-slide when they are built, so they never enter this list.
       Attribute comparison rather than a built selector keeps merchant data
       out of querySelector. */
    function slideIndexForMedia(mediaId) {
      var wanted = String(mediaId);
      var slides = gallery.querySelectorAll('[data-blossom-slide][data-arb-media-id]');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-arb-media-id') === wanted) return i;
      }
      return -1;
    }

    document.addEventListener('change', function (event) {
      var id = variantIdFrom(event.target);
      if (!id) return;

      var record = variants[String(id)];
      if (!record || !record.mediaId) return;

      /* -1 when the variant's photo is not a carousel slide: an editor can
         assign any product media, including one the gallery's own role /
         filename filter keeps out. Leave the shopper where they are rather
         than jumping somewhere arbitrary. */
      var index = slideIndexForMedia(record.mediaId);
      if (index !== -1) carousel.goToIndex(index);
    });
  }

  /* arbt (US promo overlay, 2026-10-21): snippets/arbt-promo-overlays.liquid
     renders each arbt.promo_overlays entry (the gallery's badge, and the buy
     box's note under the price) already filtered to this market, tagged with
     its variant id and verticals, and hidden unless it matches the page's first
     state. This keeps it matching when the shopper switches variant (a change
     on the Setup radio or input[name="id"], which the family swap also fires)
     or vertical without a reload (arbt:vertical-change). Blank verticals mean
     every vertical. A gallery with no entries returns at once. */
  function initPromoOverlays(root) {
    var promos = root.querySelectorAll('[data-arbt-promo]');
    if (!promos.length) return;

    var vertical = root.getAttribute('data-arbt-promo-vertical') || '';
    var variantId = '';

    function currentVariantId() {
      var setup = document.querySelector('[data-arb-setup-variant-id]:checked');
      if (setup) return setup.getAttribute('data-arb-setup-variant-id');
      var inputs = document.querySelectorAll('input[name="id"]');
      return inputs.length ? inputs[inputs.length - 1].value : '';
    }

    function paint() {
      for (var i = 0; i < promos.length; i++) {
        var verticals = promos[i].getAttribute('data-verticals');
        var verticalOk = !verticals || verticals.split(',').indexOf(vertical) !== -1;
        promos[i].hidden = !(verticalOk && promos[i].getAttribute('data-variant-id') === String(variantId));
      }
    }

    document.addEventListener('change', function (event) {
      var id = variantIdFrom(event.target);
      if (!id) return;
      variantId = id;
      paint();
    });

    document.addEventListener('arbt:vertical-change', function (event) {
      vertical = (event.detail && event.detail.vertical) || vertical;
      if (!variantId) variantId = currentVariantId();
      paint();
    });
  }

  /* arbt: ARB-172 — stage prev/next arrows. Steps the carousel one slide via
     its public goToIndex(); ends are disabled rather than wrapped, because a
     wrap would animate a scroll across the whole track. */
  function initArrows(gallery) {
    var carousel = gallery.querySelector('blossom-carousel');
    var prev = gallery.querySelector('[data-arb-gallery-prev]');
    var next = gallery.querySelector('[data-arb-gallery-next]');
    if (!carousel || !prev || !next) return;

    /* Visible only — setup-based media filtering hides slides. */
    function slideCount() {
      return gallery.querySelectorAll('blossom-carousel [data-blossom-slide]:not([hidden])').length;
    }

    function activeIndex() {
      var index = parseInt(carousel.getAttribute('data-active-index'), 10);
      return index >= 0 ? index : 0;
    }

    function syncArrows() {
      var total = slideCount();
      var index = activeIndex();
      var hide = total < 2;

      prev.hidden = hide;
      next.hidden = hide;
      prev.disabled = index <= 0;
      next.disabled = index >= total - 1;
    }

    function step(delta) {
      var index = clamp(activeIndex() + delta, 0, Math.max(slideCount() - 1, 0));
      carousel.goToIndex(index);
    }

    prev.addEventListener('click', function () {
      step(-1);
    });

    next.addEventListener('click', function () {
      step(1);
    });

    carousel.addEventListener('blossom:change', syncArrows);
    carousel.addEventListener('blossom:refresh', syncArrows);
    syncArrows();
  }

  /* a11y (ARB-323): the thumbnail strip as ONE tab stop. Left/Right/Home/End move
     between thumbs and SELECT as they go (the "one stop with arrow keys" half of the
     roving-tabindex pattern), matching the mega menu and the filter facets. Selecting
     on move is right here because the thumbs are a single-select picker, not a menu:
     there is no separate activation step to defer to. */
  function initThumbKeys(gallery) {
    var strip = gallery.querySelector('[data-arb-gallery-thumbs]');
    var carousel = gallery.querySelector('blossom-carousel');
    if (!strip || !carousel) return;

    strip.addEventListener('keydown', function (event) {
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (keys.indexOf(event.key) < 0) return;

      var dots = Array.prototype.slice.call(strip.querySelectorAll('[data-blossom-dot]')).filter(function (dot) {
        return !dot.hidden;
      });
      if (dots.length < 2) return;

      var from = dots.indexOf(document.activeElement);
      if (from < 0) return;

      var to = from;
      if (event.key === 'ArrowLeft') to = from - 1;
      else if (event.key === 'ArrowRight') to = from + 1;
      else if (event.key === 'Home') to = 0;
      else to = dots.length - 1;

      to = clamp(to, 0, dots.length - 1);
      if (to === from) return;

      event.preventDefault();
      if (typeof carousel.goToIndex === 'function') carousel.goToIndex(to);
      dots[to].tabIndex = 0;
      dots[to].focus();
      syncRovingTabindex(gallery, to);
    });

    /* The carousel is the source of truth for "which slide is active", so the roving
       state follows its events rather than being recomputed per interaction. */
    function follow() {
      var index = parseInt(carousel.getAttribute('data-active-index'), 10);
      syncRovingTabindex(gallery, index >= 0 ? index : 0);
    }
    carousel.addEventListener('blossom:change', follow);
    carousel.addEventListener('blossom:refresh', follow);
    /* Called once at init, not only on events: blossom-carousel reorders its own
       slides on upgrade, so the tabindex="0" the server put on slide 1 is not
       necessarily on the slide that ends up active. Verified on contour-sander,
       where the first activator in the runtime DOM is image 9. */
    follow();
  }

  function init() {
    document.querySelectorAll(gallerySelector).forEach(function (gallery) {
      initGallery(gallery);
      initVariantMedia(gallery);
      initPromoOverlays(gallery);
      initArrows(gallery);
      initThumbKeys(gallery);
    });
    /* The promo note lives in the buy box, outside any gallery. */
    document.querySelectorAll('[data-arbt-promo-notes]').forEach(initPromoOverlays);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
